<template>
  <el-dialog :visible="visible" title="引用套图" width="1000px" @close="close">
    <div style="padding: 10px">
      <el-button
        v-for="(item, index) in list"
        :type="activeIndex === index ? 'primary' : ''"
        :key="item.id"
        class="mt-10"
        @click="swatchItem(index)"
        >{{ item.name }}</el-button
      >
    </div>
    <el-form class="form" label-width="80px" v-if="list.length">
      <el-form-item class="draggable" v-for="(item, index) in formList" :key="item.key + '-' + index" :label="`${item.name}：`">
        <div v-if="item.key === 'speImages' && specificationName"  style="font-size: 12px;font-weight: 600;margin-bottom: 10px">规格名：{{ specificationName }}</div>
        <el-checkbox-group ref="groupRefs" v-model="item.checkList" @change="imageChange" v-if="item.imgs.length">
          <label v-for="img in item.imgs" :key="img.imageKey" class="image-item draggable">
            <ImgUpload :onlyPreview="true" :size="150" :file="img.imgUrl"></ImgUpload>
            <el-checkbox :key="img.imageKey" :label="img.imageKey" class="image-item-checkbox">{{ '' }}</el-checkbox>
            <div v-if="item.key === 'speImages'">
              <el-select v-model="img.specValue" placeholder="请选择规格值" clearable style="width: 90px">
                <el-option
                  v-for="specName in specImgNames"
                  :key="specName"
                  :label="specName"
                  :value="specName"
                  :disabled="item.imgs.findIndex(_v => _v.specValue === specName) > -1"
                >
                </el-option>
              </el-select>
            </div>
          </label>
        </el-checkbox-group>
        <span v-else>暂无数据</span>
      </el-form-item>
      <el-form-item label="全选:">
        <el-checkbox v-model="allChecked" @change="allCheckedChange"></el-checkbox>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button @click="ok('add')">引用选中图片(追加)</el-button>
      <el-button @click="ok('cover')" type="primary">引用选中图片(覆盖)</el-button>
    </template>
  </el-dialog>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';

import { cloneDeep } from 'lodash';

export default {
  components: {
    ImgUpload,
  },
  data() {
    return {
      list: [],
      imageList: [],
      opts: {},
      activeIndex: '',
      visible: false,
      allChecked: true,
      formList: [],
      specificationName: '',
      specImgNames: [],
      sortable:[],
    };
  },
  methods: {
    method_open(opts = {}) {
      this.opts = opts;
      const { list, activeIndex, hideImgs, specifications } = opts;
      this.handleSpeImages(specifications);
      this.list = list || [];
      this.imageList = this.getShowImageList(hideImgs || []);
      this.swatchItem(activeIndex || 0);
      this.visible = true;
    },
    handleSpeImages(specifications) {
      const specImgNames = [];
      if (specifications?.length) {
        this.specificationName = specifications[0].name;
        specifications[0].values.forEach(v => {
          specImgNames.push(v.value);
        });
      }
      this.specImgNames = specImgNames;
    },
    swatchItem(index) {
      this.activeIndex = index;
      const item = this.list[index];
      const formList = this.imageList.map(img => {
        const images = (item[img.key] || []).filter(Boolean);
        const checkList = [];
        img.imgs = images.map((imgUrl, idx) => {
          const imageKey = item.name + '_' + img.key + '_' + idx;
          const specValue = this.specImgNames[idx] || '';
          checkList.push(imageKey);
          return {
            imgUrl,
            imageKey,
            specValue,
          };
        });
        img.checkList = checkList;
        return img;
      });
      this.allChecked = true
      this.$set(this, 'formList', formList);
      this.$nextTick(() => {
        if (this.sortable.length) {
          this.sortable.forEach(inst => inst && inst.destroy && inst.destroy());
        }
        this.sortable = [];
        this.formList.forEach((it, idx) => this.init_sortable(it, idx));
      });
    },
    getShowImageList(hideImgs = []) {
      const imageList = [
        { key: 'mainImages', name: '商品主图', checkList: [], imgs: [] },
        { key: 'mainImages34', name: '3:4主图', checkList: [], imgs: [] },
        { key: 'detailImages', name: '商品详情图', checkList: [], imgs: [] },
        { key: 'speImages', name: '规格图', checkList: [], imgs: [] },
      ];
      return imageList.filter(item => !hideImgs.includes(item.key));
    },
    imageChange(value) {
      this.allChecked = !this.formList.some(item => item.checkList.length !== item.imgs.length);
    },
    allCheckedChange(value) {
      this.formList.forEach(item => {
        item.checkList = value ? item.imgs.map(i => i.imageKey) : [];
      });
    },
    close() {
      this.visible = false;
      this.opts = {};
      this.list = [];
      this.formList = [];
      this.sortableDestroy();
    },
    async ok(type) {
      const form = {};
      const isEmpty = !this.formList.some(item => item.checkList.length);
      if (isEmpty) {
        this.$alert('请选择图片！');
        return;
      }
      this.formList.forEach(item => {
        form[item.key] = item.checkList.map(imageKey => {
          const findIndex = item.imgs.findIndex(i => i.imageKey === imageKey);
          if (item.key === 'speImages') {
            return {
              imgUrl: item.imgs[findIndex].imgUrl,
              name: item.imgs[findIndex].specValue,
              baseIndex: findIndex,
            };
          } else {
            return item.imgs[findIndex].imgUrl;
          }
        });
      });
      console.log(cloneDeep(form), '----form---')
      this.opts.okFn && this.opts.okFn(form, type);
      this.close();
    },
    init_sortable(itemData,index) {
      if (this.sortable[index]) {
        this.sortable[index].destroy();
      }
      this.$nextTick(() => {
        const groupComp = (this.$refs.groupRefs && this.$refs.groupRefs[index]) || null;
        const container = groupComp ? (groupComp.$el || groupComp) : null;
        if (!container) {
          return;
        }
        this.sortable[index] = Sortable.create(container, {
          handle: '.image-item',
          draggable: '.image-item',
          animation: 150,
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return;
            const movedImg = itemData.imgs.splice(oldIndex, 1)[0];
            itemData.imgs.splice(newIndex, 0, movedImg);
            const displayKeys = itemData.imgs.map(i => i.imageKey);
            itemData.checkList = displayKeys.filter(k => itemData.checkList.includes(k));
            this.$forceUpdate();
          }
        });
      });
    },
    sortableDestroy(){
     if (this.sortable.length) {
       this.sortable.forEach((item,index)=>{
        this.sortable[index].destroy();
       })
       this.sortable = [];
     }
    },
  },
  mounted() {
    
  },
  beforeDestroy(){
    // 清理资源，防止内存泄漏
    this.sortableDestroy()
  }
};
</script>
<style lang="scss" scoped>
.image-item {
  width: 100px;
  position: relative;
  display: inline-block;
  vertical-align: top;
  ::v-deep .el-checkbox__input {
    position: absolute;
    top: 2px;
    right: 12px;
  }
  .image-item-checkbox {
    position: absolute;
    top: 0px;
    right: 10px;
  }
}
</style>
